import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import { NotePencil } from "@phosphor-icons/react/dist/ssr/NotePencil";
import { Trash } from "@phosphor-icons/react/dist/ssr/Trash";

interface AnnouncementCardProps {
  announcement: {
    id: string;
    title: string;
    message: string;
    created: string;
    expirationDate?: string;
  };
  isActive: boolean;
  onEdit: (announcement: any) => void;
  onDelete: (announcementId: string, title: string) => void;
}

const AnnouncementCard: React.FC<AnnouncementCardProps> = ({ announcement, isActive, onEdit, onDelete }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <View style={styles.announcementCard}>
      <View style={styles.cardHeader}>
        <View style={styles.cardHeaderLeft}>
          <CustomText
            text={`Posted on ${formatDate(announcement.created)}`}
            size="xs"
            style={styles.dateText}
            useTranslationText={false}
          />
          {announcement.expirationDate && (
            <>
              <CustomText text=" • " size="xs" style={styles.dateText} useTranslationText={false} />
              <CustomText
                text={`Expires ${formatDate(announcement.expirationDate)}`}
                size="xs"
                style={styles.dateText}
                useTranslationText={false}
              />
            </>
          )}
        </View>
        <View style={styles.cardActions}>
          <CustomButton
            styleType="transparent"
            leftIcon={<NotePencil size={20} color="#98A2B3" />}
            onPress={() => onEdit(announcement)}
            style={styles.actionButton}
          />
          <CustomButton
            styleType="transparent"
            leftIcon={<Trash size={20} color="#98A2B3" />}
            onPress={() => onDelete(announcement.id, announcement.title)}
            style={styles.actionButton}
          />
        </View>
      </View>
      <CustomSpacing type="vertical" size="s" />
      <CustomText
        text={announcement.title}
        size="s"
        weight="ultraBold"
        style={styles.announcementTitle}
        useTranslationText={false}
      />
      <CustomSpacing type="vertical" size="s" />
      <CustomText
        text={announcement.message.replace(/<[^>]*>/g, "")}
        size="s"
        style={styles.announcementMessage}
        useTranslationText={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  announcementCard: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 20,
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  cardHeaderLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  cardActions: {
    flexDirection: "row",
    alignItems: "center",
  },
  actionButton: {
    padding: 4,
    marginLeft: 8,
  },
  dateText: {
    color: "#98A2B3",
    fontWeight: "600",
  },
  announcementTitle: {
    color: "#344054",
    fontWeight: "700",
  },
  announcementMessage: {
    color: "#667085",
    lineHeight: 20,
  },
});

export default AnnouncementCard;
